/* ============================================================
   GOLGEN 集合页 PC 排序 — all-watches-collection.liquid 按需加载
   选中排序项即带 sort_by 参数跳转（保留 filter 等其他查询参数）；
   圆点回选与 summary 文案由 Liquid 按 collection.sort_by 服务端渲染。
   移动端排序由 golgen-mobile.js 处理，本文件只绑定 PC 控件。
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('input[name="aw-sort-pc"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', radio.value);
        window.location.href = url.href;
      });
    });
  });
})();
